import { defineComponent as _defineComponent } from 'vue'
import {ref} from 'vue';
import {getSpecsById} from '@/api/miscellaneous';

export default /*#__PURE__*/_defineComponent({
  __name: 'Specifications',
  props: {
    id: {
        type: String,
        default: '',
    },
},
  emits: ['confirm'],
  setup(__props, { expose, emit }) {
  expose();

const props = __props



const data = ref([]);

const attr = ref<any[]>([]);

const getAttr = () => {
    getSpecsById({id: props.id}).then((res: any) => {
        attr.value = res;
        setData(res);
    });
};
getAttr();

const setData = (val: any) => {
    let specificationData = val.map((el: any) => {
        const {name, id, unit, attributeType} = el;
        let value: string | string[] = '';
        switch (attributeType) {
            case 'range':
                value = ['', ''];
                break;
            case 'select':
                value = '';
                break;
        }
        return {name, id, unit, value};
    });
    data.value = specificationData;
};

const confirm = () => {
    emit(
        'confirm',
        data.value.filter((el: any) => el.value.length != 0),
    );
};

const __returned__ = { props, emit, data, attr, getAttr, setData, confirm, ref, getSpecsById }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})